import { css } from "styled-components";

const BREAKPOINT_TABLET = 768;
const BREAKPOINT_DESKTOP = 960;

export const actionContainerStyles = css`
  text-align: left;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  margin: 0;
  padding: 0;
  border-radius: 5px;
  background: #fff;
  box-shadow: 2px 5px 5px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: none;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  box-sizing: border-box;

  @media (min-width: 600px) {
    max-width: 320px;
  }

  @media (min-width: ${BREAKPOINT_TABLET}px) {
    flex: 0 0 280px;
    max-width: 280px;
  }

  @media (min-width: ${BREAKPOINT_DESKTOP}px) {
    flex: 0 0 25%;
    max-width: none;
  }
`;

export const actionLinkStyles = css`
  text-align: left;
  font-family: "Source Sans Pro", sans-serif !important;
  list-style: inside none;
  text-indent: -1em;
  margin: 0;
  outline: none;
  font-weight: normal;
  display: block;
  width: 100%;
  color: #2C4960;
  text-decoration: none;
  padding: 8px 0px;
  font-size: 12px !important;
  cursor: pointer;
`;

export const actionHeaderStyles = css`
  text-align: left;
  margin: 0;
  margin-bottom: 0;
  font-weight: normal;
  padding: 8px 12px;
  color: #fff;
  background: #2C4960;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  border-radius: 5px 5px 0 0;
`;
